import "@luminecence/composants/variables.css"
import Firebase from "./src/js/connexion/Firebase.js"
import "./src/js/transverse/Routeur.js"
import "@luminecence/composants/PopupInformation"
import { registerSW } from "virtual:pwa-register"
import PopupBase from "@luminecence/composants/PopupBase"

window.authentification = new Firebase()

window.addEventListener("load", async () => {
  await window.authentification.attendreAuthPret()

  const pokemons = await fetch("https://tyradex.app/api/v1/pokemon")
  window.listePokemons = pokemons.ok ? await pokemons.json() : []

  // Evite d'afficher le contenu pre-rendu et la SPA en doublon.
  document.getElementById("prerender-content")?.remove()

  if (!document.querySelector("p-routeur")) {
    document.body.insertAdjacentHTML("afterbegin", "<p-routeur></p-routeur>")
  }
})

// On utilise registerSW en pointant explicitement sur ton fichier Firebase
const updateSW = registerSW({
  immediate: true,
  // On précise à Vite d'utiliser TON fichier qui contient Firebase + PWA
  scriptType: "classic",
  src: "/firebase-messaging-sw.js",

  async onNeedRefresh() {
    const resultat = await PopupBase.ouvrirEtAttendre("p-popup-information", {
      titre: "Mise a jour disponible",
      texte: "Une nouvelle version est disponible. Appuyez sur OK pour recharger l'application.",
      modal: true,
    })

    if (resultat) {
      updateSW(true)
    }
  },
  onRegistered(registration) {
    if (!registration) return

    // Vérification quand l'app revient au premier plan
    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "visible") {
        registration.update()
      }
    })

    // Vérification toutes les minutes
    setInterval(() => {
      registration.update()
    }, 60 * 1000)

    console.log("SW Firebase & PWA surveille pour les mises a jour !")
  },
  onRegisterError(error) {
    console.error("Erreur enregistrement service worker:", error)
  },
})